define('view/helper/TemplatePartials',['require','handlebars'],function (require) {

	var Handlebars = require('handlebars');

    Handlebars.registerPartial('bookingInfoPart', jQuery('#booking_info_part').html());
    Handlebars.registerPartial('bookingInfoPartPrice', jQuery('#booking_info_part_price').html());
    Handlebars.registerPartial('bookingInfoSideBarPart', jQuery('#datetime_booking_info_sidebar').html());
    Handlebars.registerPartial('bookingInfoSideBarListPart', jQuery('#datetime_booking_info_sidebar_list').html());
    Handlebars.registerPartial('bookingTimeLegendPart', jQuery('#time_legend_part').html());
    Handlebars.registerPartial('bookingPackageLink', jQuery('#booking_details_package_link').html());
    Handlebars.registerPartial('preloaderPart', jQuery('#preloader_part').html());
    Handlebars.registerPartial('emptyTimePart', jQuery('#empty_time_part').html());
    Handlebars.registerPartial('emptyWeekTimePart', jQuery('#empty_week_time_part').html());
    Handlebars.registerPartial('mainPageContactsPart', jQuery('#index_contacts_part').html());
    Handlebars.registerPartial('mainPageAboutUsPart', jQuery('#index_about_us_part').html());
    Handlebars.registerPartial('mainPageWorkingHoursPart', jQuery('#index_working_hours_part').html());
    Handlebars.registerPartial('formInput', jQuery('#part_form_input').html());
    Handlebars.registerPartial('formEmail', jQuery('#part_form_email').html());
    Handlebars.registerPartial('formPhone', jQuery('#part_form_phone').html());
    Handlebars.registerPartial('formPassword', jQuery('#part_form_password').html());
    Handlebars.registerPartial('formSelect', jQuery('#part_form_select').html());
    Handlebars.registerPartial('formCheckbox', jQuery('#part_form_checkbox').html());
    Handlebars.registerPartial('formLabel', jQuery('#part_form_label').html());
    Handlebars.registerPartial('formLabelSelect', jQuery('#part_form_label_select').html());
    Handlebars.registerPartial('serviceBar', jQuery('#service_bar').html());
    Handlebars.registerPartial('gdprReportTable', jQuery('#gdpr_report_table').html());
    Handlebars.registerPartial('gdprReportTableBookings', jQuery('#gdpr_report_table_bookings').html());
    Handlebars.registerPartial('gdprReportTableSoapCrypt', jQuery('#gdpr_report_table_soap_crypt').html());
    Handlebars.registerPartial('gdprReportTableSoap', jQuery('#gdpr_report_table_soap').html());
    Handlebars.registerPartial('cookiesBlock', jQuery('#cookies_block').html());
    Handlebars.registerPartial('userTermsAndConditionsLink', jQuery('#user_terms_and_conditions').html());
    Handlebars.registerPartial('termsAndConditionsLang', jQuery('#terms_and_conditions_lang').html());
    Handlebars.registerPartial('footer', jQuery('#footer_part').html());

});

